






























import Vue from 'vue'

export default Vue.extend({
  name: 'ProfileMenu',

  computed: {
    hasLoyaltyAccount () {
      return Boolean(this.$store.state.user?.loyaltyAccount)
    }
  },

  methods: {
    logout () {
      // @TODO: Логику перехода переместить в beforeRouteEnter страниц профиля пользователя
      if (this.$route.name?.includes('user')) {
        this.$router.push('/')
      }

      this.$store.dispatch('logout')
    }
  }
})
